'use client';

import { UserDocument } from 'models/user';
import EditSizesForm from './forms/EditSizesForm';
import MobileDrawer from '@c/drawers/MobileDrawer';

type Props = {
  open: boolean;
  dismiss: () => void;
  userDoc: UserDocument;
  handleSizeSelection: any;
};

export default function MobileEditSizesModal({
  open,
  dismiss,
  userDoc,
  handleSizeSelection,
}: Props) {
  return (
    <MobileDrawer show={open} dismiss={dismiss} title="My Sizes">
      <EditSizesForm userDoc={userDoc} dismiss={dismiss} />
    </MobileDrawer>
  );
}
